import { render, staticRenderFns } from "./UbicazioniDetails.vue?vue&type=template&id=25e7ecf0&scoped=true"
import script from "./UbicazioniDetails.vue?vue&type=script&lang=js"
export * from "./UbicazioniDetails.vue?vue&type=script&lang=js"
import style0 from "./UbicazioniDetails.vue?vue&type=style&index=0&id=25e7ecf0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25e7ecf0",
  null
  
)

export default component.exports